import { Store } from 'redux';
import { getAccessToken } from 'utils/helpers';

import { RequestMainService } from '../request';
import {
  GET_MAINTENANCE_CONFIG,
  GET_MAINTENANCE_CONFIG_ERROR,
} from './maintenance.reduce';
import {
  GET_WITHDRAW_CONFIG,
  GET_WITHDRAW_CONFIG_ERROR,
} from './withdraw.reduce';
export class ConfigService {
  static async getServerConfigWithdraw(store: Store) {
    const token = getAccessToken();
    if (token)
      return RequestMainService.get(`/admin/get-server-config`)
        .then(({ result }) => {
          const data = result.find(
            (v: any) => v.serverConfigName === 'WITHDRAW_LIMIT_CONFIG',
          );
          const { USER_MAXIMUM_IN_DAY, SYSTEM_MAXIMUM_IN_DAY } = JSON.parse(
            data.value,
          );
          store.dispatch({
            type: GET_WITHDRAW_CONFIG,
            data: { USER_MAXIMUM_IN_DAY, SYSTEM_MAXIMUM_IN_DAY },
          });
        })
        .catch((res) =>
          store.dispatch({
            type: GET_WITHDRAW_CONFIG_ERROR,
            error: res.error,
          }),
        );
  }

  static async setConfig(payload: any) {
    return RequestMainService.post(`/admin/server-config`, payload);
  }

  static async getServerConfigMaintenance(store: Store) {
    const token = getAccessToken();
    if (token)
      return RequestMainService.get(`/admin/get-maintenance-server`)
        .then(({ result }) => {
          store.dispatch({ type: GET_MAINTENANCE_CONFIG, data: result });
        })
        .catch((res) =>
          store.dispatch({
            type: GET_MAINTENANCE_CONFIG_ERROR,
            error: res.error,
          }),
        );
  }

  static async swithMaintenanceServer(enable: any) {
    return RequestMainService.post(`/admin/switch-maintenance-server`, enable);
  }

  static async getListAnnouncement() {
    return RequestMainService.get('/admin/announcement').then((res) => ({
      count: res.result.total,
      data: res.result.data.sort(
        (a: any, b: any) => a.poolStreakId - b.poolStreakId,
      ),
    }));
  }

  static async editAnnouncement(id: number, payload: any) {
    return RequestMainService.put(`/admin/announcement/${id}`, payload);
  }

  static async createAnnouncement(payload: any) {
    return RequestMainService.post('/admin/announcement', payload);
  }
}
